import { render, staticRenderFns } from "./visit.vue?vue&type=template&id=1c633dcd&scoped=true"
import script from "./visit.vue?vue&type=script&lang=js"
export * from "./visit.vue?vue&type=script&lang=js"
import style0 from "./visit.vue?vue&type=style&index=0&id=1c633dcd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c633dcd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c633dcd')) {
      api.createRecord('1c633dcd', component.options)
    } else {
      api.reload('1c633dcd', component.options)
    }
    module.hot.accept("./visit.vue?vue&type=template&id=1c633dcd&scoped=true", function () {
      api.rerender('1c633dcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/visitRecords/visit.vue"
export default component.exports